
const getData = ({config, path, queryParams, get}) => {
    const params = [];
    Object.getOwnPropertyNames(queryParams).forEach(param =>{
        const value = queryParams[param]||[];
        params.push(`${param}=${(value.join(","))}`);
    })
    return new Promise((resolve, reject) => {
        get(`${config.rmmApi}${path}?` + params.join('&')).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            console.error(error);
            reject(error);
        });      
    });
};

const rmmServices = angular.module('rmmServices', []);


rmmServices.service('rmmDataFetch', function($http, config) {
    return {
        /**
         *
         * @param {string[]} queryparams
         * @param {string[]} trains
         * @param {string[]} fleets
         * @param {Date} startDatetime
         * @param {Date} endDatetime
         * @returns {Promise}
         */
        all({queryParams, path}) {
            return getData({
                get: $http.get,
                config,
                path,
                queryParams
            })
        }
    };
});

